<template>
  <div class="flex-row absolute-center welcome">
    <img src="../../assets/images/index.png" alt="welcome" />
  </div>
</template>

<script>
export default {
  name: "welcome",
  data() {
    return {};
  },
  mounted() {},
  methods: {
    // handleClose(done) {
    //   this.$confirm("确认关闭？")
    //     .then((_) => {
    //       done();
    //     })
    //     .catch((_) => {});
    // },
  },
};
</script>

<style scoped>
.welcome {
  margin-top: 10vh;
}
</style>



// WEBPACK FOOTER //
// src/view/page/Welcome.vue